import React, {useContext} from "react";
import {Typography, Space} from "@bezlimit/bezlimit-ui";
import {useTranslation} from "react-i18next";
import {observer} from "mobx-react";
import _ from "lodash";
import "./style.scss";

// forms
import EditEmailForm from "../../forms/editEmail";
// core
import {LayoutContext} from "../../../core/Contexts";

export default React.memo(
    observer(function EditEmailModal({email}: Props) {
        const contextLayout = useContext(LayoutContext);
        const {t} = useTranslation();

        return (
            <Typography as="div" className="bl-edit-email-modal">
                <Space
                    size={_.gte(contextLayout?.width ?? 0, 768) ? 40 : 24}
                    direction="vertical"
                    align="center"
                >
                    <Typography as="div">
                        <Space size={8} direction="vertical" align="center">
                            <Typography
                                size={_.gte(contextLayout?.width ?? 0, 768) ? 24 : 17}
                                level={2}
                                color="#000000"
                            >
                                {t("Сменить электронную почту")}
                            </Typography>
                            <Typography color="#000000" className="subtitle">
                                {t("Подтвержденный адрес электронной почты дает возможность ")}
                                <br />
                                {t("восстановить доступ к аккаунту в любой момент")}
                            </Typography>
                        </Space>
                    </Typography>
                    <EditEmailForm email={email} />
                </Space>
            </Typography>
        );
    })
);

interface Props {
    email: string;
}
